import { DropdownValue } from '../@types/types'

export const COUNTRY_CODE_GERMANY = 276

export function isGermanCountryCode(countryCode: number | DropdownValue): boolean {
  return countryCode !== null && String(countryCode) === String(COUNTRY_CODE_GERMANY)
}
